// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"652":"8a46c1c2","699":"c52105ac"}[chunkId] + ".chunk.js";
};